import createGetCaptchaActionEnabled from './createGetCaptchaActionEnabled';
import getReCaptcha2PublicConfig from './getReCaptcha2PublicConfig.client';

/**
 * Returns whether captcha is enabled for the given action.
 *
 * Returns whether or not the specific action given is enabled. If the broader
 * captcha system is disabled for the current context, this will return false
 * regardless of the action.
 */
const getCaptchaActionEnabled = createGetCaptchaActionEnabled(getReCaptcha2PublicConfig());

export default getCaptchaActionEnabled;
